
import axios from 'axios';
import React, { useEffect, useState } from 'react';



function Logo() {

    const [logo, setLogo] = useState("");


    useEffect(() => {
        let config = {
            method: "get",
             url: "https://intranet-backend.procuratio.com/tablet/lmiv.php",
            //url: "../mock/MOCK_DATA.json",

            headers: {
                Accept: "application/json"
            }
        };

        axios(config)
            .then(function (res) {
                setLogo(res.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }, []);


    return (

        <div className="logo-container">
            
           

        </div>
    )
}

export default Logo;
